import { render } from "./ManageMedia.vue?vue&type=template&id=2dccae60&scoped=true"
import script from "./ManageMedia.vue?vue&type=script&lang=js"
export * from "./ManageMedia.vue?vue&type=script&lang=js"

import "./ManageMedia.vue?vue&type=style&index=0&id=2dccae60&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dccae60"]])

export default __exports__